import ts from 'typescript';
import type { Evaluator } from '../types';

const evaluateNumericLiteral: Evaluator<ts.NumericLiteral> = ({ node }): number => Number(node.text);

export default evaluateNumericLiteral;
